<main class="container">
  <div>
    <h2 class="text-center">RECONTACT SURVEY</h2>
  </div>

  <div
    class="alert alert-warning d-flex align-items-center justify-content-center my-5"
    role="alert"
    *ngIf="isAidaEnabled"
  >
    <img
      class="stars-img"
      src="./../../../../assets/image/blue-stars.svg"
      alt="Blue stars icon"
    />

    <span>
      This feature is not available because AIDA™ (AI Delivery Assistant) is
      enabled.
    </span>
  </div>

  <form [formGroup]="form">
    <!-- Metadata -->
    <div class="row survey_form">
      <div class="col-md-12 form-group">
        <label>SURVEY TITLE</label>
        <input
          type="text"
          class="form-control survey-style"
          formControlName="surveyTitle"
        />
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="row survey_form double-line">
      <div class="col-md-5 div-margin">
        <div class="col-md-6 col-lg-6 form-group">
          <label>COUNTRY</label>
          <ps-ui-select-dropdown
            [disabled]="isEditMode === true"
            [multi]="false"
            formControlName="selectedCountry"
            [firstSelected]="selectedFirst"
            [dropdownItems]="countries"
            [field]="'name'"
            labelNone="Select Country"
            (selectedItem)="selectRecontactCountry($event)"
          >
          </ps-ui-select-dropdown>
        </div>
        <div class="col-md-6 col-lg-6 form-group">
          <label>LANGUAGE</label>
          <ps-ui-select-dropdown
            [disabled]="isEditMode === true"
            [dropdownItems]="languages"
            [firstSelected]="true"
            [field]="'name'"
            labelNone="Select Language"
            (selectedItem)="setRecontactLanguage($event)"
          >
          </ps-ui-select-dropdown>
        </div>
      </div>
      <div class="col-md-7 div-margin">
        <div class="col-md-4 col-lg-4 form-group place_holder">
          <label
            >Length of <br />
            Survey</label
          >
          <input
            [attr.disabled]="isEditMode === true ? '' : null"
            type="number"
            class="form-control survey-style"
            formControlName="lengthOfSurvey"
            oninput="if(this.value.length>2){ this.value = this.value.slice(0,2) }"
          />
          <span>mins</span>
        </div>
        <div class="col-md-4 col-lg-4 form-group place_holder">
          <label>Incidence</label>
          <input
            [attr.disabled]="isEditMode === true ? '' : null"
            type="number"
            class="form-control survey-style"
            name="incidence"
            formControlName="incidence"
            oninput="if(this.value.length>2){ this.value = this.value.slice(0,2) }"
          />
          <span>%</span>
        </div>
        <div class="col-md-4 col-lg-4 form-group place_holder">
          <label for="field_time">FIELD TIME</label>
          <input
            type="number"
            class="form-control border-less-input survey-style"
            formControlName="fieldTime"
          />
          <span>days</span>
        </div>
      </div>
    </div>
    <!-- qualification -->
    <div class="row survey_form">
      <ng-container *ngFor="let qualification of qualifications">
        <div class="col-md-4 col-lg-3 form-group">
          <div class="row">
            <div class="col-6">
              <label>
                {{ qualification?.qualification_name }}
              </label>
            </div>
          </div>
          <ps-ui-multiselect-input-button
            [qualification]="qualification"
            [quotas]="qualification.quotas"
            [addQuotaFlag]="false"
            (selectionChange)="setQualification($event)"
            [disabled]="isAidaEnabled"
          >
          </ps-ui-multiselect-input-button>
        </div>
      </ng-container>
    </div>
    <!-- unique link toggle -->
    <div class="row survey_form text-center">
      <div><strong>Link</strong></div>
      <br />
      <br />
      <div>
        <span class="link-text">General Link</span>
        <label class="switch">
          <input
            type="checkbox"
            (change)="clearUploadedRefList()"
            formControlName="uniqueLinks"
          />
          <span class="slider round"></span>
        </label>
        <span class="link-text">Unique Link</span>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- survey entry link -->
    <div class="row survey_form">
      <div class="col-md-8 form-group">
        <label class="d-inline-block mb-0">Survey Entry Link</label>
        <div class="tooltip-visible d-inline-block">
          <div
            class="fa fa-info-circle ml-0 setting-info"
            aria-hidden="true"
            *ngIf="!form.value.uniqueLinks"
          >
            <p>
              <span *ngIf="form.value.surveyEntryLink">
                Your URL settings transform the Entry URL into:
                http://test?transaction_id = [%ps_transaction_id%]
              </span>
              <span *ngIf="!form.value.surveyEntryLink"
                >Please enter your Survey URL to check its final form.
              </span>
            </p>
          </div>
        </div>
        <input
          type="text"
          [readonly]="form.value.uniqueLinks === true"
          class="form-control survey-style"
          formControlName="surveyEntryLink"
        />
      </div>
      <div class="col-md-4 form-group">
        <label class="d-inline-block mb-0">Billing</label>
        <span
          *ngIf="
            (billingRule$ | async)?.mandatory || isMandatoryBillingNumberEnabled
          "
        >
          *
        </span>
        <ps-ui-billing-number-tooltip
          class="d-inline-block billing-rule-tooltip"
          [rules]="billingRule$ | async"
        ></ps-ui-billing-number-tooltip>
        <input
          type="text"
          placeholder="Billing number"
          class="form-control survey-style"
          formControlName="poNumber"
        />
        <p
          *ngIf="billingRule$ | async as billingRule"
          class="billing-rule-example"
        >
          {{ 'Example: ' + billingRule.example }}
        </p>
      </div>
    </div>
    <!-- Test entry link -->
    <div class="row survey_form">
      <div class="col-md-8 form-group">
        <label class="d-inline-block mb-0">Test Entry Link</label>
        <div class="tooltip-visible d-inline-block">
          <div
            class="fa fa-info-circle setting-info"
            *ngIf="!form.value.uniqueLinks"
            aria-hidden="true"
          >
            <p>
              <span *ngIf="form.value.testEntryLink">
                Your ENTRY LINK settings transform the ENTRY LINK into:
                http://test?transaction_id = [%ps_transaction_id%]
              </span>
              <span *ngIf="!form.value.testEntryLink">
                Your TEST ENTRY LINK is empty, we will use your SURVEY ENTRY
                LINK as the TEST ENTRY LINK. Please add a TEST ENTRY LINK if it
                is different than the SURVEY ENTRY LINK.
              </span>
            </p>
          </div>
        </div>
        <input
          type="text"
          class="form-control survey-style"
          formControlName="testEntryLink"
        />
      </div>
      <div class="col-md-4 form-group">
        <label></label>
        <button
          class="test-link-btn btn btn-primary text-decoration-none"
          [disabled]="isAidaEnabled"
          (click)="saveSurveyDetails(false, true)"
        >
          <span>Test Link</span>
        </button>
      </div>
    </div>
    <!-- upload respondent list -->
    <div class="row survey_form">
      <div class="col-md-12 form-group">
        <label>Upload Respondent List</label>
      </div>
      <div class="row text-center">
        <header class="flex-container flex-center color-green">
          <ul class="style-none">
            <li>
              <input
                #fileUpload
                hidden
                type="file"
                class="file-upload"
                accept=".csv"
                (change)="uploadRespondentFile($event)"
              />
              <button
                type="button"
                class="btn upload-button"
                (click)="fileUpload.value = ''; fileUpload.click()"
                [disabled]="isAidaEnabled"
              >
                Upload a file
              </button>
            </li>
            <li>
              <span class="csv-span">.csv</span>
            </li>
            <br />
            <li>
              <a
                target="_blank"
                class="text-decoration-none"
                href="{{ psidTemplatePath }}"
              >
                Download Template
              </a>
              <a
                href="javascript:void(0)"
                class="download-template-img text-decoration-none"
                >?</a
              >
            </li>
            <br />
            <ng-container *ngIf="psidFilePath">
              <li>
                <a class="link-cursor" (click)="viewLatestUpload()"
                  >View Latest Upload</a
                >
              </li>
              <li>
                <h6 class="or-span">or</h6>
              </li>
              <li>
                <a class="link-cursor" (click)="clearRespondentList()"
                  ><span>Clear Respondent List</span></a
                >
              </li>
            </ng-container>
          </ul>
        </header>
      </div>
    </div>
    <!-- launch buttons -->
    <div class="row">
      <div class="col-md-6" *ngIf="isEditMode === false">
        <button
          class="btn btn-primary launch-btn"
          (click)="saveSurveyDetails(false)"
        >
          Save
        </button>
      </div>
      <div class="col-md-6" *ngIf="isEditMode === true">
        <button class="btn btn-primary launch-btn" (click)="goToDashboard()">
          Cancel
        </button>
      </div>
      <div class="col-md-6 text-right" *ngIf="isEditMode === false">
        <button
          class="btn btn-primary launch-btn"
          (click)="saveSurveyDetails(true)"
        >
          Launch
        </button>
      </div>
      <div class="col-md-6 text-right" *ngIf="isEditMode === true">
        <button
          class="btn btn-primary launch-btn"
          [disabled]="isAidaEnabled"
          (click)="updateSurveyDetails()"
        >
          {{ editLabel }}
        </button>
      </div>
    </div>
  </form>
</main>
